<app-content-container>
  <app-campaigns-banner [addButtonConfiguration]="addButtonConfiguration" [adminMode]="false" />
  <app-campaigns-datatable
    data-testid="campaigns-datatable"
    [campaigns]="store.campaigns$()"
    [total]="store.total$()"
    [campaignsLoading]="store.campaignsLoading$()"
  />
</app-content-container>
